import { PropsWithChildren } from 'react';

import * as Sentry from '@sentry/react';

import { Icons, Stack } from '@cast/design-system';
import { FailedToLoad } from '@cast/shared-messages-ui';

export const OneClickPageErrorBoundary = ({ children }: PropsWithChildren) => (
  <Sentry.ErrorBoundary
    fallback={
      <Stack
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
        pt="max(50px, 20vh)"
      >
        <FailedToLoad icon={<Icons.XCircle weight="fill" />} iconSize={80} />
      </Stack>
    }
  >
    {children}
  </Sentry.ErrorBoundary>
);
